import { Typography } from '@sanlam-glacier/app-common/components';
import { useGetBranding } from '@sanlam-glacier/app-common/modules/theme';
import styles from './mobile-not-supported.module.scss';
import { useConfig } from 'providers/config/ConfigProvider';

export const MobileNotSupported = () => {
  const { theme } = useConfig();
  const { glacierLogoColor } = useGetBranding(theme);
  return (
    <div className='mobile-content'>
      <div className={styles.mobileNotSupportedLayout}>
        <div className={styles.mobileNotSupportedImageContainer}>
          <img
            alt='Mobile not supported'
            loading='lazy'
            src={glacierLogoColor}
            className={styles.mobileNotSupportedImage}
          />
        </div>
        <div className={styles.mobileNotSupportedContainer}>
          <Typography
            align={Typography.ALIGN.CENTER}
            variant={Typography.VARIANT.H3}
            color={Typography.COLOR.PRIMARY}
          >
            Screen size is not supported.
          </Typography>
          <Typography
            variant={Typography.VARIANT.B2}
            align={Typography.ALIGN.CENTER}
            color={Typography.COLOR.INHERIT}
          >
            This website is not optimised for this screen size at the moment. For the best
            experience, please increase your screen size, switch to landscape view if you're on a
            tablet, or use a different device.
          </Typography>
        </div>
        <div className={styles.mobileNotSupportedFooter}>
          <Typography
            variant={Typography.VARIANT.B4}
            align={Typography.ALIGN.CENTER}
            color={Typography.COLOR.TERTIARY}
          >
            Glacier Financial Solutions (Pty) Ltd is a licensed financial services provider. Sanlam
            Life Insurance Ltd is a licensed life insurer, financial services and registered credit
            provider (NCRCP43).
          </Typography>
        </div>
      </div>
    </div>
  );
};
